import styled from 'styled-components'

export const PackageSizeInput = styled.div`
  input {
    cursor: pointer;
  }
`
